import React from "react";
import {ValueValidator} from "../Validator";
import {CustomInputField} from "../../customInputField/CustomInputField";
import {OnValidChangeHandler, ValidationComponent, ValidationFieldName} from "./ValidationComponent";
import {RootState} from "../../../../app/store";

interface Props<PROPERTY, OBJECT> {
    validator: ValueValidator<PROPERTY>
    selector: (state: RootState) => PROPERTY | undefined
    fieldName: ValidationFieldName<OBJECT>
    onChange: (value: PROPERTY) => any
    updateValidationStatus: OnValidChangeHandler<OBJECT>
    label: string
    placeholder?: string
    disabled?: boolean
    required?: boolean
    getMessage: (f: string) => string
    unit?: string
    maxLength?: number
}

export const ValidatedInputField = <PROPERTY, OBJECT>({
                                                          validator,
                                                          selector,
                                                          fieldName,
                                                          onChange,
                                                          updateValidationStatus,
                                                          label,
                                                          placeholder,
                                                          disabled,
                                                          getMessage,
                                                          required = true,
                                                          unit,
                                                          maxLength
                                                      }: Props<PROPERTY, OBJECT>) => {
    return <ValidationComponent<PROPERTY, OBJECT>
        onChange={onChange}
        updateValidationStatus={updateValidationStatus}
        fieldName={fieldName}
        required={required}
        selector={selector}
        disabled={disabled}
        validator={validator}
        label={label}
        child={(label, value, onChange, required) =>
            <CustomInputField
                isRequired={required}
                title={label}
                value={value}
                disabled={disabled}
                setValue={onChange}
                placeholder={placeholder}
                errorMessage={getMessage(fieldName as string)}
                unit={unit}
                maxLength={maxLength}
            />
        }
    />
}
